import { observer } from 'mobx-react-lite';
import { useCommercialStore } from 'src/context';
import { SaveStatus } from '../SaveStatusIndicator';
import { AddNewButton } from '../AddNewButton';
import { BulkDeleteButton } from '../BulkDeleteButton';
import { PageHeader } from '../PageHeader';

export type EditsHeaderProps = {
  onCreateCommercial: () => void;
  onDeleteCommercials: () => void;
  /** How many commercials are checked; their delete button shows once there's one */
  selectedCommercialCount: number;
};

export const EditsHeader = observer(
  ({ onCreateCommercial, onDeleteCommercials, selectedCommercialCount }: EditsHeaderProps) => {
    /** Context **/
    const commercialStore = useCommercialStore();

    /** Computed **/
    const saveStatus = commercialStore.isSaving ? SaveStatus.Saving : SaveStatus.Saved;

    /** Render **/
    return (
      <PageHeader
        title="Commercial Edits"
        saveStatus={saveStatus}
        actions={
          <>
            <AddNewButton onClick={onCreateCommercial} label="New commercial" />
            <BulkDeleteButton
              count={selectedCommercialCount}
              singular="commercial"
              plural="commercials"
              onDelete={onDeleteCommercials}
              confirm={false}
            />
          </>
        }
      />
    );
  }
);
